import React, { useState } from 'react';
import { connect, useDispatch, useSelector } from 'react-redux';
import { Select, Button, Modal, Alert, message, Tooltip, Icon } from 'antd';
import { Grid } from '@material-ui/core';
import TextEvents from '../TextEvents';
import TextInput from 'app/components/TextInput';
import { styles, useStyles } from './ClientProcedureFormStyles';
import ClientProcedureTableContainer from 'app/containers/ClientProcedureTableContainer';
import CompanyTableContainer from 'app/containers/CompanyTableContainer';
import { fetchClientProcedure, fetchClientProcedureFilter, clientProcedureClear, clientProcedureFilterClear } from 'app/actions/ClientProcedureActions';

import ApiService from 'app/services/ApiService';

const { confirm } = Modal;
const { Option } = Select;
const SelectItem = (name = [], value) => {
    let x = name[value]
    return typeof x !== 'undefined' && x !== null ? x.map((c, i) => <Option key={i}>{c}</Option>) : (x === null ? <Option key={'cargando'}>No existen valores..</Option> : <Option disabled key={'cargando'}>Cargando valores..</Option>);

}

export default function ClientProcedureForm(props) {
    const classes = useStyles();
    const dispatch = useDispatch();
    const [name, setName] = useState([]);
    const [nameClient, setNameClient] = useState([]);
    const [collapse, setCollapse] = useState(true);

    const { siteId } = useSelector(state => state.Auth);

    const data = {
        procedureName: props.FiltroClasificacion.join('|'),
        clientName: props.FiltroCompany.join('|'),
        idProcedureType: '1',
        sortColumn: Object.keys(props.sorter).length > 0 ? props.sorter.field : '',
        sortDir: Object.keys(props.sorter).length > 0 ? props.sorter.order === "ascend" ? "ASC" : "DESC" : '',
        offset: (0 * props.pagination.pageSize),
        limit: props.pagination.pageSize
    }

    const SelectCompanyItem = (name = [], value) => {
        let x = [...new Set(name.map(i => i[value]))];
        x = name.map(i => i[value]);
        return (
            x.map((c, i) => <Option key={i}>{c}</Option>)
        );
    }

    const findSubdir = (params, item) => {
        let temp = [];
        params.company.forEach(v => {
            if (String(v.idClient) === item.key) temp.push(v);

        });
        if (temp.length > 0)
            props.setIdClient(String(temp[0].idClient));

    }

    const submit = () => {
        ApiService.setProcedure({ idProcedure: props.idProcedure, procedureName: props.nameProcedure, idClient: props.idClient, idProcedureType: 1 }, props.idProcedure > 0 ? 'PUT' : 'POST').then(
            res => {
                props.isVisibleForm(false)
                message.success(`La Clasificación ${props.nameProcedure} se guardó correctamente!`);
                dispatch(clientProcedureFilterClear());
                dispatch(fetchClientProcedureFilter({ IdProcedureType: '1' }));
                search();
                props.setNameProcedure('');
            },
            error => {
                message.error('Ocurrió un error intente mas tarde.');
            }
        );
    }
    const search = () => {
        dispatch(clientProcedureClear());
        dispatch(fetchClientProcedure(data));
        props.setFormData(data);
    }

    const newProcedure = () => {
        props.setIdProcedure(0);
        props.setIdClient('0');
        props.setNameProcedure('');
        props.isVisibleForm(true);
    }

    const toExport = async () => {
        await ApiService.getClientProcedureExport(data)
            .then(
                result => {
                    const blob = new Blob([result], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                    downloadFile(blob, "BandejaProcedimientosClientes.xlsx");
                },
                error => {
                    // throw ({ error: error, message: 'An error ocurred' });
                }
            )
    }

    const downloadFile = (blob, fileName) => {
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = fileName;
        document.body.append(link);
        link.click();
        link.remove();
        window.addEventListener('focus', e => URL.revokeObjectURL(link.href), { once: true });
    };

    const handleChange = (value, i, key) => {
        const array = [];
        i.map(i => {
            array.push(i.props.children);
            return array;
        })
        if (i.length === 0) {
            switch (key) {
                case 'procedureName':
                    setName([])
                    props.setFiltroClasificacion([]);
                    break;
                case 'clientName':
                    setNameClient([])
                    props.setFiltroCompany([]);
                    break;
                default:
                    break;
            }
        }
        // eslint-disable-next-line array-callback-return
        i.map(() => {
            if (key === 'procedureName') {
                setName([array])
                props.setFiltroClasificacion(array);
            }
            else if (key === 'clientName') {
                setNameClient([array])
                props.setFiltroCompany(array);
            }
        });
    }

    return (
        <div>
            <ClientProcedureTableContainer>
                {(params) => {
                    return (
                        <div>
                            <div hidden={collapse}>
                                <Grid container direction="row">
                                    <Grid item xs={6}>
                                        <TextEvents
                                            text='Clasificación:'
                                            color="darker"
                                            size='label'
                                            weight="medium"
                                        />
                                        <Select
                                            mode="multiple"
                                            showSearch
                                            value={props.FiltroClasificacion}
                                            optionFilterProp="children"
                                            style={{ ...styles.fullWidth, ...styles.smallBottomMargin }}
                                            placeholder="Selecciona clasificación"
                                            onChange={(v, i) => handleChange(v, i, 'procedureName')}
                                        >
                                            {SelectItem(params.clientProcedureFilter[0], 'name')}
                                        </Select>
                                    </Grid>
                                    <Grid item xs={6}>
                                        <TextEvents
                                            text='Compañía:'
                                            color="darker"
                                            size='label'
                                            weight="medium"
                                        />
                                        <CompanyTableContainer>
                                            {(params) => {
                                                return (
                                                    <Select
                                                        mode="multiple"
                                                        showSearch
                                                        value={props.FiltroCompany}
                                                        optionFilterProp="children"
                                                        style={{ ...styles.fullWidth, ...styles.smallBottomMargin }}
                                                        placeholder="Selecciona compañía"
                                                        onChange={(v, i) => handleChange(v, i, 'clientName')}

                                                    >
                                                        {SelectCompanyItem(params.company, 'clientName')}
                                                    </Select>
                                                )
                                            }}
                                        </CompanyTableContainer>
                                    </Grid>
                                </Grid>
                            </div>
                            <div className={classes.container} style={styles.baseVerticalMargin}>
                                {
                                    collapse ?
                                        <Tooltip title={"Mostrar filtro"}>
                                            <Button
                                                className={classes.button}
                                                variant="contained"
                                                type="link"
                                                onClick={() => setCollapse(false)}
                                            >
                                                <Icon type="down" />
                                            </Button>
                                        </Tooltip> :
                                        <Tooltip title={"Ocultar filtro"}>
                                            <Button
                                                className={classes.button}
                                                variant="contained"
                                                type="link"
                                                onClick={() => setCollapse(true)}
                                            >
                                                <Icon type="up" />
                                            </Button>
                                        </Tooltip>
                                }
                                <Button
                                    className={classes.button}
                                    variant="contained"
                                    type="primary"
                                    onClick={() => search()}
                                >
                                    Buscar
                                </Button>
                                <Button
                                    className={classes.button}
                                    variant="contained"
                                    type="primary"
                                    onClick={toExport}
                                >
                                    Exportar
                                </Button>
                                {
                                    siteId === 'HUB' ?
                                        <Button
                                            className={classes.button}
                                            variant="contained"
                                            type="primary"
                                            onClick={newProcedure}
                                        >
                                            Nuevo
                                        </Button> : null
                                }
                            </div>
                        </div>
                    )
                }}
            </ClientProcedureTableContainer>
            <Modal
                destroyOnClose={true}
                onCancel={() => props.isVisibleForm(false)}
                visible={props.visibleForm}
                title={<TextEvents
                    text={props.idProcedure > 0 ? 'Editar Clasificación de Procedimiento de Cliente' : 'Nueva Clasificación de Procedimiento de Cliente'}
                    color='cotemar'
                    size='label'
                    weight='bold'
                />}
                width={'650px'}
                centered={true}
                footer={[
                    <Button key="back" type="danger" ghost onClick={() => props.isVisibleForm(false)}>
                        Cancelar
                    </Button>,
                    siteId === 'HUB' ?
                        <Button disabled={props.nameProcedure === '' || props.idClient === '0'} key="submit" type="primary" loading={false} onClick={() => submit()}>
                            Confirmar
                        </Button> : null,
                ]}
            >
                <Grid container direction="row">

                    <Grid item xs={12} style={{ marginTop: '10px' }}>
                        <TextInput
                            disabled={siteId !== 'HUB'}
                            value={props.nameProcedure}
                            setValue={props.setNameProcedure}
                            text='Clasificación:'
                            color='darker'
                            size='label'
                            weight='medium'
                            mode='input'
                            placeholder='Nombre'
                        />
                    </Grid>

                    <Grid item xs={12} >
                        <TextEvents
                            text='Compañía:'
                            color='darker'
                            size='label'
                            weight='medium'
                        />
                        <CompanyTableContainer>
                            {(params) => {
                                findSubdir(params, { key: props.idClient });
                                return (
                                    <Select
                                        showSearch
                                        disabled={siteId !== 'HUB'}
                                        labelInValue
                                        value={{ key: props.idClient !== '0' ? props.idClient : null }}
                                        style={{ width: "100%" }}
                                        onChange={(item) => {
                                            findSubdir(params, item);
                                        }}
                                    >
                                        {
                                            params.company.map((item) => {

                                                return (
                                                    <Select.Option key={String(item.idClient)} value={String(item.idClient)}>
                                                        {item.clientName}
                                                    </Select.Option>
                                                )
                                            })
                                        }
                                    </Select>
                                )
                            }}
                        </CompanyTableContainer>

                    </Grid>
                </Grid>
            </Modal>
        </div>
    );
}